import Axios from "axios";

const operatorsModule = {
    namespaced: true,
    state: {
        list: [],
        loaded: false,
        promise: null,
    },
    actions: {
        async loadList ({ state, commit }) {
            if (state.promise) {
                return state.promise;
            }

            let promise = Axios({
                url: '/api/v1/operators',
                method: 'GET',
            }).then(resp => {
                commit('SET_LIST', resp.data.items);
                commit('SET_LOADED', true);
            });

            commit('SET_PROMISE', promise);

            return promise;
        },
    },
    mutations: {
        SET_LIST: (state, payload) => {
            state.list = payload;
        },
        SET_LOADED: (state, payload) => {
            state.loaded = payload;
        },
        SET_PROMISE: (state, payload) => {
            state.promise = payload;
        },
    },
    getters: {
        list: (state) => state.list,
        loaded: (state) => state.loaded,
    }
};

export default operatorsModule;
